//=====================================================
//　テーマカラー設定
//=====================================================

import { useContext } from 'react';
import { CtxClinicInfo } from '../utils/Contexts';

interface IFProps {
    children: any
}

export function ThemeColor(props:IFProps){

    const uci = useContext(CtxClinicInfo);

    return (
        <div className={uci.data.themeColor}>{props.children}</div>
    )

}